import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pui-spinner',
    template: ` <div class="spinner-wrapper"></div> `,
    styleUrls: ['./p-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
// This class should be used in p-loading only, please don't use directly
export class PSpinnerComponent {
    @Input()
    closable = false;

    @Output()
    closed = new EventEmitter();
}
